<template>
    <footer class="footer">
        <div class="footer-main">
            <div class="footer-content">
                <!-- 品牌區塊 -->
                <div class="footer-brand">
                    <div class="footer-brand__name">臺中市足球委員會</div>
                    <p class="footer-brand__sub">TAICHUNG FOOTBALL COMMITTEE</p>
                    <p class="footer-brand__desc">
                        臺中市體育總會足球委員會致力於推廣足球運動，提供優質的訓練環境與比賽機會，促進臺中市足球運動發展。
                    </p>
                    <div class="social-links">
                        <a href="https://www.facebook.com/groups/576604161850781" target="_blank" class="social-icon">
                            <i class="fab fa-facebook-f"></i>
                        </a>
                        <a href="https://line.me/ti/p/@677ciirx" target="_blank" class="social-icon">
                            <i class="fab fa-line"></i>
                        </a>
                        <a href="mailto:service@tcfc.org.tw" class="social-icon">
                            <i class="fas fa-envelope"></i>
                        </a>
                    </div>
                </div>

                <!-- 網站導覽 -->
                <div class="footer-section">
                    <h4>網站導覽</h4>
                    <ul class="footer-links">
                        <li><a href="javascript:void(0)">組織簡介</a></li>
                        <li><a href="javascript:void(0)">願景與使命</a></li>
                        <li><a href="javascript:void(0)">組織架構</a></li>
                        <li><a href="javascript:void(0)">主席簡介</a></li>
                        <li><a href="javascript:void(0)">地方聯絡窗口</a></li>
                    </ul>
                </div>

                <!-- 服務項目 -->
                <div class="footer-section">
                    <h4>服務項目</h4>
                    <ul class="footer-links">
                        <li><a href="javascript:void(0)">規章制度</a></li>
                        <li><a href="javascript:void(0)">財務報告</a></li>
                        <li><a href="javascript:void(0)">會議紀錄</a></li>
                        <li><a href="javascript:void(0)">活動資訊</a></li>
                        <li><a href="javascript:void(0)">比賽公告</a></li>
                    </ul>
                </div>

                <!-- 聯絡我們 -->
                <div class="footer-section">
                    <h4>聯絡我們</h4>
                    <div class="contact-info">
                        <p class="contact-info__label">PHONE</p>
                        <p class="contact-info__value"><a href="tel:+88422588185">2258 8185</a></p>
                        <p class="contact-info__label">EMAIL</p>
                        <p class="contact-info__value"><a href="mailto:service@tcfc.org.tw">service@tcfc.org.tw</a></p>
                        <p class="contact-info__label">ADDRESS</p>
                        <p class="contact-info__value">407027 台中市西屯區朝馬路108號</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer-bottom">
            <p>&copy; 2025 TCFC 臺中市體育總會足球委員會. All Rights Reserved.</p>
        </div>
    </footer>
</template>
